<div class="user-verification" [class.user-verification--visible]="visibility">
    <div class="page-head">
        <app-back (onBack)="onBack()"></app-back>
        <h1 class="title title--size-l text--center">{{'VERIFICATION.TITLE' | translate}}</h1>
    </div>
    <div class="page-content page-row">
        <div class="page-content page-row" *ngIf="mfaAvailability === false">
            <div class="row-content" *ngIf="!processing">
                <app-touch-id class="icon__touch-id"></app-touch-id>
                <p class="text text--size-l text--extra-bold">{{'VERIFICATION.VERIFY-IDENTITY' | translate}}</p>
                <p class="text">{{'VERIFICATION.VERIFY-DESCRIPTION' | translate}}</p>
            </div>
            <div class="row-content" *ngIf="processing">
                <app-processing class="icon__touch-id"></app-processing>
                <p class="text text--size-l text--extra-bold">...{{'COMMON.STATES.PROCESSING' | translate}}...</p>
            </div>
        </div>

        <div class="page-content page-row" *ngIf="mfaAvailability === true">
            <div class="row-content" *ngIf="!processing">
                <app-touch-id class="icon__touch-id"></app-touch-id>
                <p class="text text--size-l text--extra-bold">{{'VERIFICATION.VERIFY-IDENTITY' | translate}}</p>
            </div>
            <div class="row-content" *ngIf="processing && transactionId <= 0">
                <app-processing class="icon__touch-id"></app-processing>
                <p class="text text--size-l text--extra-bold">{{'VERIFICATION.CREATING' | translate}}</p>
            </div>
            <div class="row-content" *ngIf="processing && transactionId > 0">
                <app-hyper-id class="icon__touch-id"></app-hyper-id>
                <p class="text text--size-l text--extra-bold text--center"
                    [innerHTML]="'VERIFICATION.HYPER-ID' | translate:({code: actionCode})"></p>
                <div class="wrapper--center" *ngIf='hyperIdAuthenticatorAppUrl'
                    style="margin-top: 48px; margin-bottom: 16px;">
                    <a [href]="hyperIdAuthenticatorAppUrl">
                        <button class="btn sign-in__btn"
                            [innerHTML]="'VERIFICATION.VERIFY' | translate">HyperID</button>
                    </a>
                </div>
            </div>
        </div>

        <button *ngIf="transactionId <= 0" [disabled]="processing" class="btn"
            (click)="startVerificate()">{{'VERIFICATION.VERIFY' | translate}}</button>
    </div>
</div>
